import oneTimeLiveLessonEndedMutation from '../mutations/OneTimeLiveLessonEnded.gql'

export default function (variables) {
  return {
    mutation: oneTimeLiveLessonEndedMutation,
    variables: variables,
  }
}
